import Image1 from "../../assets/testimonial1.png";
import Image2 from "../../assets/testimonial2.png";
import Image3 from "../../assets/testimonial3.png";


export const Data = [
  {
    id: 1,
    image: Image1,
    title: "John Boye",
    description: "Excellent web development! Sam delivered a fast, responsive site that exceeded our expectations.",
  },
  {
    id: 2,
    image: Image2,
    title: "Mr. Lanre",
    description: "Our new website, developed by Sam and his team, works perfectly and has greatly enhanced user satisfaction.",
  },
  {
    id: 3,
    image: Image3,
    title: "Kazeem Fashola",
    description: "The website you built for us is outstanding—clean, functional, and easy to use. It’s transformed our online presence.",
  },
];
